import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default () => ({
  path: ":curriculumProgramId",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "globalModuleSettings" */ "GlobalModuleSettings/components/SchoolLevelGlobalModuleSettings"
      ),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
});
